import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import * as styles from "./mainLayout.module.scss";

import mainLayoutWire from "../../assets/illustrations/mainLayoutWire.svg";

const MainLayout = ({ children }) => {
    return (
        <div>
            {/* <div className={styles.backgroundWire} style={{backgroundImage : `url(${mainLayoutWire})`}} /> */}
            <Header/>
            <main className={styles.mainContainer}>{children}</main>
            <Footer />
        </div>
    )
}

export default MainLayout;